import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width={8} height={13} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.249.819a1.2 1.2 0 010 1.697L3.297 6.467l3.952 3.952a1.2 1.2 0 01-1.697 1.697l-4.8-4.8a1.2 1.2 0 010-1.697l4.8-4.8a1.2 1.2 0 011.697 0z"
        fill="#9AA1B7"
      />
    </svg>
  );
}

export default SvgComponent;
